!(function () {
  "use strict";
  var t = "lp_ref",
    n = "cpid",
    e = "lpurl",
    r = "https://abc.ebanpick.com",
    c = "(?<domain>http(?:s?)://[^/]*)".concat("/cf/click"),
    a = "(?:(?:/(?<cta>[1-9][0-9]*)/?)|(?:/))?",
    i = "^".concat(c).concat(a).concat("(?:$|(\\?.*))"),
    o = 'javascript:window.clickflare.l="(?<original_link>'
      .concat(c)
      .concat(a, '("|(\\?[^"]*"))).*'),
    s = function () {
      return new RegExp(i, "");
    },
    u = function () {
      return new RegExp(o, "");
    };
  function l(t) {
    var n = (function (t) {
      return t.replace(s(), function (t) {
        for (var n = [], e = 1; e < arguments.length; e++)
          n[e - 1] = arguments[e];
        var c = n[n.length - 1].domain;
        return t.replace(c, r);
      });
    })(t);
    return 'javascript:window.clickflare.l="'.concat(n, '"; void 0;');
  }
  function f(t, n) {
    if (
      (n && t && n.apply(document, [t]),
      /loaded|interactive|complete/.test(document.readyState))
    )
      for (var e = 0, r = document.links.length; e < r; e++)
        if (s().test(document.links[e].href)) {
          var c = document.links[e];
          window.clickflare.links_replaced.has(c) ||
            ((c.href = l(c.href)), window.clickflare.links_replaced.add(c));
        }
  }
  !(function (c, a) {
    var i = document.onreadystatechange;
    window.clickflare ||
      ((window.clickflare = {
        listeners: {},
        customParams: {},
        links_replaced: new Set(),
        addEventListener: function (t, n) {
          var e = this.listeners[t] || [];
          e.includes(n) || e.push(n), (this.listeners[t] = e);
        },
        dispatchEvent: function (t, n) {
          n && (this.customParams[t] = n),
            (this.listeners[t] || []).forEach(function (t) {
              return t(n);
            });
        },
        push: function (t, n) {
          n && (this.customParams[t] = n),
            (this.listeners[t] || []).forEach(function (t) {
              return t(n);
            });
        },
      }),
      (document.onreadystatechange = function (t) {
        return f(t, i);
      }),
      f(null, i),
      setTimeout(function () {
        !(function (c, a) {
          var i,
            o = (function (c, a) {
              var i = new URL("".concat(r).concat(c)),
                o = "{",
                s = o + o;
              a.startsWith(s) || i.searchParams.set(n, a);
              return (
                i.searchParams.append(t, document.referrer),
                i.searchParams.append(e, location.href),
                i.searchParams.append("lpt", document.title),
                i.searchParams.append("t", new Date().getTime().toString()),
                i.toString()
              );
            })(c, a),
            s = document.createElement("script"),
            l = document.scripts[0];
          (s.async = 1),
            (s.src = o),
            (s.onerror = function () {
              !(function () {
                for (
                  var t = function (t, n) {
                      var e = document.links[t];
                      u().test(e.href) &&
                        setTimeout(function () {
                          e &&
                            e.setAttribute(
                              "href",
                              (function (t) {
                                var n = t.match(u());
                                if (n) {
                                  var e = (n.groups || {}).original_link;
                                  return e ? e.slice(0, -1) : t;
                                }
                                return t;
                              })(e.href)
                            );
                        });
                    },
                    n = 0,
                    e = document.links.length;
                  n < e;
                  n++
                )
                  t(n);
              })();
            }),
            null === (i = l.parentNode) || void 0 === i || i.insertBefore(s, l);
        })(c, a);
      }));
  })(
    ""
      .concat("/cf/tags", "/")
      .concat(
        new URL(window.location.href).searchParams.get("cftmid") ||
          "67f4c8a64729690012407676"
      ),
    new URL(window.location.href).searchParams.get(n) ||
      "67f4c8a64729690012407676"
  );
})();
